"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactRedux = require("react-redux");
var _Modal = require("@ccw-pwa-ui/Modal");
var _ImageUpload = _interopRequireDefault(require("../components/ImageUpload"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _Services = require("../common_features/utility/Services");
var _helper = require("../common_features/utility/helper");
var _lodash = _interopRequireDefault(require("lodash"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _browserImageCompression = _interopRequireDefault(require("browser-image-compression"));
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ImageUploadContainer = () => {
  var _location$state, _location$state2, _location$state3, _location$state4, _location$state$navHe, _location$state5;
  const windowLayout = (0, _helper.getPlatformType)();
  const location = (0, _reactRouterDom.useLocation)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const fromScreen = location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.fromScreen;
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [description, setDescription] = (0, _react.useState)([]);
  const [selectedImages, setSelectedImages] = (0, _react.useState)([]);
  const [displayModal, setDisplayModal] = (0, _react.useState)(false);
  const [success, setSuccessModal] = (0, _react.useState)(false);
  const [noImage, setNoImage] = (0, _react.useState)(false);
  const [disable, setDisabled] = (0, _react.useState)(false);
  const [currentImage, setCurrentImage] = (0, _react.useState)(null);
  let [path, setImagePath] = (0, _react.useState)([]);
  let imagePathList = [];
  let imagePaths = [...imagePathList];
  const [isOneSelected, setOneSelected] = (0, _react.useState)(!(0, _helper.getPlatformType)());
  const [response, setResponse] = (0, _react.useState)({});
  const [cameraStream, setCameraStream] = (0, _react.useState)(false);
  const [uploadingVisible, setUploadingVisible] = (0, _react.useState)(false);
  const [uploading, setUploading] = (0, _react.useState)(true);
  const [totalImagesUploaded, setTotalImagesUploaded] = (0, _react.useState)(0);
  const [notUploaded, setNotUploaded] = (0, _react.useState)(false);
  const [totalImagesSelected, setTotalImagesSelected] = (0, _react.useState)(0);
  const [isLimitExceeded, setisLimitExceeded] = (0, _react.useState)(false);
  const [deleteModal, setdeleteModal] = (0, _react.useState)(false);
  const [imageCount, setImageCount] = (0, _react.useState)(0);
  const [serviceData, setServiceData] = (0, _react.useState)({});
  const [isTwoSelected, setTwoSelected] = (0, _react.useState)((0, _helper.getPlatformType)());
  const [initialImages, setInitialImages] = (0, _react.useState)([]);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const sysId = (0, _react.useRef)(0);
  const videoRef = (0, _react.useRef)(null);
  const {
    selectedSystems,
    selectedDetails,
    imageDataAdded
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const filterDetail = location === null || location === void 0 ? void 0 : (_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.filterDetail;
  const changesFlag = location === null || location === void 0 ? void 0 : (_location$state3 = location.state) === null || _location$state3 === void 0 ? void 0 : _location$state3.changesFlag;
  const accessoryData = location === null || location === void 0 ? void 0 : (_location$state4 = location.state) === null || _location$state4 === void 0 ? void 0 : _location$state4.systemData;
  const navHeading = (_location$state$navHe = location === null || location === void 0 ? void 0 : (_location$state5 = location.state) === null || _location$state5 === void 0 ? void 0 : _location$state5.navHeading) !== null && _location$state$navHe !== void 0 ? _location$state$navHe : "System Dashboard";
  const continueClicked = async () => {
    setIsLoading(true);
    if (fromScreen === "editPhoto") {
      await systemAPI();
      setSuccessModal(true);
    } else {
      await systemAPI();
    }
    setIsLoading(false);
  };
  const successModalTitle = () => {
    if (fromScreen === "editFilter") {
      return "Filter Updated";
    } else if (fromScreen === "editAccessory") {
      return "Accessory Updated";
    } else if (fromScreen === "addAccessory") {
      return "Accessory Added";
    } else {
      return "System Updated";
    }
  };
  const successModalDetail = () => {
    if (fromScreen === "editFilter") {
      return "The filter has been updated Successfully.";
    } else if (fromScreen === "editAccessory") {
      return "The accessory has been updated Successfully.";
    } else if (fromScreen === "addAccessory") {
      const refModel = filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.map(item => item.refAppModelNumber);
      return "The below accessories have been added to your view ".concat(refModel);
    } else {
      return "The system has been updated Successfully.";
    }
  };
  const systemAPI = async () => {
    var _filterDetail$systemI, _response$ServiceLogN, _location$state6, _response$ServiceLogN2, _response$ServiceLogN3;
    const systemId = (_filterDetail$systemI = filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.systemId) !== null && _filterDetail$systemI !== void 0 ? _filterDetail$systemI : selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId;
    const storeId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.storeId;
    const orgId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.orgId;
    const ServiceLogImageUrls = [];
    if (path !== null && path !== void 0 && path.length) {
      for (let i = 0; i < path.length; i++) {
        path.length && ServiceLogImageUrls.push({
          imageUrl: path[i] || "",
          imageDescription: description[i] || ""
        });
      }
    }
    let payloadForImages = {
      systemId: systemId,
      storeId: storeId,
      orgId: orgId,
      installedDate: response.serviceLogsType === "2" ? selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.installedDate : null,
      waterDest: response.serviceLogsType === "3" ? response.waterDest : null,
      ServiceLogNote: response !== null && response !== void 0 && (_response$ServiceLogN = response.ServiceLogNotes) !== null && _response$ServiceLogN !== void 0 && _response$ServiceLogN.length ? {
        note: response === null || response === void 0 ? void 0 : response.ServiceLogNotes[0].note
      } : null,
      ServiceLogImageUrls: ServiceLogImageUrls
    };
    let refAppId = location === null || location === void 0 ? void 0 : (_location$state6 = location.state) === null || _location$state6 === void 0 ? void 0 : _location$state6.refAppId;
    let systemData = fromScreen !== "editPhoto" && {
      refAppId: refAppId || (filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.refAppId),
      refAppInstallationDate: filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.refAppInstallationDate,
      refAppName: filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.refAppModelNumber,
      refAppType: filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.refAppType,
      selectedRefAppLife: filterDetail !== null && filterDetail !== void 0 && filterDetail.selectedRefAppLife ? filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.selectedRefAppLife : null,
      ServiceLogNote: response !== null && response !== void 0 && (_response$ServiceLogN2 = response.ServiceLogNotes) !== null && _response$ServiceLogN2 !== void 0 && _response$ServiceLogN2.length ? {
        note: response === null || response === void 0 ? void 0 : response.ServiceLogNotes[0].note
      } : null,
      ServiceLogImageUrls: ServiceLogImageUrls
    };
    dispatch((0, _systemsReducer.imageData)(ServiceLogImageUrls));
    let systemReferences = [];
    systemReferences.push(Object.entries(systemData).reduce((data, _ref) => {
      let [k, v] = _ref;
      return v == null ? data : (data[k] = v, data);
    }, {}));
    let payloadForFilter = {
      systemId: systemId,
      storeId: storeId,
      orgId: orgId,
      systemReferences: systemReferences,
      refAppId: refAppId
    };
    let payloadForAddAccessory = {
      systemId: systemId,
      storeId: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.storeId,
      orgId: orgId,
      systemData: accessoryData,
      ServiceLogImageUrls: ServiceLogImageUrls,
      refAppId: refAppId
    };
    payloadForImages = Object.entries(payloadForImages).reduce((data, _ref2) => {
      let [k, v] = _ref2;
      return v == null ? data : (data[k] = v, data);
    }, {});
    let payload = fromScreen === "editPhoto" ? payloadForImages : payloadForFilter;
    payload = fromScreen === "addAccessory" ? payloadForAddAccessory : payload;
    fromScreen === "editPhoto" && (await (0, _Services.updateSystem)(payload));
    fromScreen !== "editPhoto" && navigate(_RoutePath.default.addNotes.useLink, {
      state: {
        payload: payload,
        fromScreen: fromScreen,
        notes: response !== null && response !== void 0 && (_response$ServiceLogN3 = response.ServiceLogNotes) !== null && _response$ServiceLogN3 !== void 0 && _response$ServiceLogN3.length ? response === null || response === void 0 ? void 0 : response.ServiceLogNotes[0].note : "",
        navHeading: "Add Photos",
        changesFlag: changesFlag || !_lodash.default.isEqual(initialImages, path),
        serviceLogType: getType(),
        successModalTitle: successModalTitle(),
        successModalDetail: successModalDetail(),
        refAppId: refAppId
      }
    });
  };
  const handleCancelbtn = () => {
    navigate(_RoutePath.default.systemDetail.useLink);
  };
  const handlebackPress = () => {
    navigate(-1);
  };
  const uploadPhotos = () => {
    setUploadingVisible(false);
    setDisplayModal(true);
  };
  const onOptionSelect = key => {
    if (key === 1) {
      setOneSelected(true);
      setTwoSelected(false);
    } else {
      setTwoSelected(true);
      setOneSelected(false);
    }
  };
  const onModalCancel = () => {
    setTwoSelected((0, _helper.getPlatformType)());
    setOneSelected(!(0, _helper.getPlatformType)());
    setDisplayModal(false);
  };
  const limitOkPress = () => {
    setisLimitExceeded(false);
  };
  const imageNotUploadedClick = () => {
    setNotUploaded(false);
  };
  const deleteHandler = () => {
    setdeleteModal(false);
    setUploadingVisible(false);
    const indexInSelectedImages = selectedImages.indexOf(currentImage);
    if (indexInSelectedImages !== -1) {
      const updatedSelectedImages = selectedImages.filter((e, index) => index !== indexInSelectedImages);
      const updatedDescription = description.filter((e, index) => index !== indexInSelectedImages);
      setDescription(updatedDescription);
      setSelectedImages(updatedSelectedImages);
      const updatedPath = path.filter((e, index) => index !== indexInSelectedImages);
      setImagePath(updatedPath);
      dispatch((0, _systemsReducer.imageData)(updatedPath));
    }
    setDisabled(imageDataAdded === path);
    URL.revokeObjectURL(currentImage);
    setUploading(false);
  };
  const deleteIconClick = image => {
    setCurrentImage(image);
    setdeleteModal(true);
  };
  const onCancelDelete = () => {
    setdeleteModal(false);
  };
  const b64toBlob = function (b64Data) {
    let contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    let sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType
    });
    return blob;
  };
  const fetchImage = async image => {
    let result = [];
    let imageToUse = (imageDataAdded === null || imageDataAdded === void 0 ? void 0 : imageDataAdded.length) !== 0 ? imageDataAdded === null || imageDataAdded === void 0 ? void 0 : imageDataAdded.map(i => i === null || i === void 0 ? void 0 : i.imageUrl) : image;
    try {
      await Promise.all(imageToUse === null || imageToUse === void 0 ? void 0 : imageToUse.map(async imgPath => {
        const resp = await (0, _Services.imageGet)(imgPath);
        const blobData = b64toBlob(atob(resp).split(",")[1].slice(0, -1));
        result.push(blobData);
        const imgArray = result.map(file => {
          return URL.createObjectURL(file);
        });
        setIsLoading(false);
        setSelectedImages(imgArray);
      }));
      setUploading(false);
      setIsLoading(false);
    } catch (error) {
      setUploading(false);
      setIsLoading(false);
      console.log(error, "fetchImage api error");
    }
  };
  const getType = () => {
    if (fromScreen === "editPhoto") {
      return _helper.SERVICE_LOGS_TYPE.IMAGES_UPDATED;
    }
    if (fromScreen === "editFilter") {
      return _helper.SERVICE_LOGS_TYPE.REPLACEMENT_PART_UPDATED;
    }
    if (fromScreen === "editAccessory") {
      return _helper.SERVICE_LOGS_TYPE.ACCESSORY_UPDATED;
    } else {
      return _helper.SERVICE_LOGS_TYPE.ACCESSORY_ADDED;
    }
  };
  const getData = () => {
    var _filterDetail$systemI2;
    setIsLoading(true);
    if (!_lodash.default.isEmpty(selectedDetails)) {
      setIsLoading(false);
      return;
    }
    const type = getType();
    const sysId = (_filterDetail$systemI2 = filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.systemId) !== null && _filterDetail$systemI2 !== void 0 ? _filterDetail$systemI2 : selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId;
    const refAppId = filterDetail !== null && filterDetail !== void 0 && filterDetail.refAppId ? filterDetail === null || filterDetail === void 0 ? void 0 : filterDetail.refAppId : null;
    fromScreen !== "addAccessory" && (0, _Services.getLastServiceRecordByType)(sysId, type, refAppId).then(data => {
      var _data$data, _data$data2, _data$data2$ServiceLo, _data$data3, _data$data4, _data$data4$ServiceLo, _data$data5, _data$data6, _data$data6$ServiceLo;
      setResponse(data === null || data === void 0 ? void 0 : data.data);
      setImageCount(data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.ServiceLogImageUrls ? data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : (_data$data2$ServiceLo = _data$data2.ServiceLogImageUrls) === null || _data$data2$ServiceLo === void 0 ? void 0 : _data$data2$ServiceLo.length : imageCount);
      let images = data !== null && data !== void 0 && (_data$data3 = data.data) !== null && _data$data3 !== void 0 && _data$data3.ServiceLogImageUrls ? data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : (_data$data4$ServiceLo = _data$data4.ServiceLogImageUrls) === null || _data$data4$ServiceLo === void 0 ? void 0 : _data$data4$ServiceLo.map(item => item === null || item === void 0 ? void 0 : item.imageUrl) : [];
      setSelectedImages(previousImages => previousImages.concat(images));
      const imageDescription = data !== null && data !== void 0 && (_data$data5 = data.data) !== null && _data$data5 !== void 0 && _data$data5.ServiceLogImageUrls ? data === null || data === void 0 ? void 0 : (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : (_data$data6$ServiceLo = _data$data6.ServiceLogImageUrls) === null || _data$data6$ServiceLo === void 0 ? void 0 : _data$data6$ServiceLo.map(item => item === null || item === void 0 ? void 0 : item.imageDescription) : '';
      let ServiceLogImageUrls = [];
      for (let i = 0; i < (images === null || images === void 0 ? void 0 : images.length); i++) {
        images.length && ServiceLogImageUrls.push({
          imageUrl: images[i] || "",
          imageDescription: imageDescription[i] || ""
        });
      }
      (images === null || images === void 0 ? void 0 : images.length) && dispatch((0, _systemsReducer.imageData)(ServiceLogImageUrls));
      setInitialImages(images);
      (images === null || images === void 0 ? void 0 : images.length) && setImagePath(images);
      setDescription(imageDescription);
      setDisabled(images === path);
      images.length && fetchImage(images);
      setIsLoading(false);
    }).catch(e => {
      console.log(e);
      setIsLoading(false);
    });
    setUploading(false);
  };
  (0, _react.useEffect)(() => {
    let images = (imageDataAdded === null || imageDataAdded === void 0 ? void 0 : imageDataAdded.length) !== 0 ? imageDataAdded === null || imageDataAdded === void 0 ? void 0 : imageDataAdded.map(i => i.imageUrl) : [];
    if ((images === null || images === void 0 ? void 0 : images.length) > 0) {
      let imageIndex = 0;
      const sortedArray = (0, _helper.sortAlphaNumericArray)(images);
      imageIndex = (0, _helper.extractNumberFromString)(sortedArray[0].substring(sortedArray[0].length - 10));
      imageIndex++;
      setImageCount(imageIndex);
    }
  }, []);
  const handleFileUpload = async (img, index) => {
    const file = img;
    const base64 = await (0, _helper.convertToBase64)(file);
    const imageIndex = imageCount + index;
    let serviceId = selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.serviceId;
    await (0, _Services.imageUpload)(base64, "/".concat(sysId.current, "/").concat(serviceId, "/systemImage-").concat(imageIndex, ".png"));
    imagePaths.push("/".concat(sysId.current, "/").concat(serviceId, "/systemImage-").concat(imageIndex, ".png"));
    setImagePath(prev => [...prev, "/".concat(sysId.current, "/").concat(serviceId, "/systemImage-").concat(imageIndex, ".png")]);
  };
  const uploadImages = async imageFiles => {
    try {
      await Promise.all(imageFiles.map(async (img, index) => {
        await handleFileUpload(img, index);
      }));
      setTotalImagesUploaded(imageFiles.length);
      setImageCount(imageCount + imageFiles.length);
    } catch (error) {
      console.log(error, "uploadImages api error");
      setNotUploaded(true);
    }
  };
  const handleFileChange = async event => {
    setDisplayModal(false);
    setIsLoading(true);
    const imageFile = event.target.files;
    setTotalImagesSelected(imageFile.length);
    let selectedFiles = [];
    const options = {
      maxSizeMB: 6,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    };
    if (imageFile.length > 10) {
      if (path.length === 0) setNoImage(true);
      setisLimitExceeded(true);
    } else {
      setNoImage(false);
      try {
        const compressedFiles = await Promise.all(Array.from(imageFile).map(async file => {
          const compressedFile = await (0, _browserImageCompression.default)(file, options);
          return compressedFile;
        }));
        selectedFiles = selectedFiles.concat(compressedFiles);
      } catch (error) {
        console.log(error);
      }
      //  setIsLoading(true);
      if (path.length <= 10 && selectedFiles.length + path.length <= 10) {
        var _selectedFiles;
        setUploadingVisible(true);
        await uploadImages(selectedFiles);
        const imagesArray1 = (_selectedFiles = selectedFiles) === null || _selectedFiles === void 0 ? void 0 : _selectedFiles.map(file => {
          return URL.createObjectURL(file);
        });
        setSelectedImages(previousImages => previousImages.concat(imagesArray1));
        setUploading(false);
        setIsLoading(false);
      } else {
        setUploading(false);
        setIsLoading(false);
        setisLimitExceeded(true);
      }
    }
    setIsLoading(false);
    // FOR BUG IN CHROME
    event.target.value = "";
  };
  const successContinue = async () => {
    navigate(_RoutePath.default.systemDetail.useLink);
  };
  (0, _react.useEffect)(() => {
    if (fromScreen === 'addAccessory' || changesFlag === true) {
      setIsLoading(false);
    } else {
      getData();
      setIsLoading(false);
    }
  }, []);
  return isLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ImageUpload.default, {
    isUpdating: isLoading,
    navHeading: navHeading,
    onBackPress: handlebackPress,
    onClickCancel: handleCancelbtn,
    leftArrow: _images.default.leftArrow.default,
    cancelText: "Cancel",
    headerText: "Add Photos",
    subContent: "Add Photos",
    description: description,
    descriptionChange: (e, index) => {
      const newInput = e.target.value;
      const descriptionList = [...description];
      descriptionList[index] = newInput;
      setDescription(descriptionList);
    },
    uploading: uploading,
    uploadingVisible: uploadingVisible,
    totalImagesUploaded: totalImagesUploaded,
    totalImagesSelected: totalImagesSelected,
    buttonTitle: "Upload Photos",
    uploadDisabled: (path === null || path === void 0 ? void 0 : path.length) == 10 ? true : false,
    uploadPhotos: uploadPhotos,
    checkmark: _images.default.checkmark.default,
    checkmarkStyle: {
      marginLeft: "303px",
      marginTop: "-40px"
    },
    displayPhotosModal: displayModal,
    isOneSelected: isOneSelected,
    onOptionSelect: onOptionSelect,
    isTwoSelected: isTwoSelected,
    cameraStream: cameraStream,
    videoRef: videoRef,
    handleFileChange: handleFileChange,
    onModalCancel: onModalCancel,
    selectedImages: selectedImages,
    limitExceededText: "Limit Exceeded",
    limitDetailText: noImage ? "You can upload maximum 10 photos only." : "Maximum 10 photos can be uploaded. ".concat(10 - path.length, " photos remaining."),
    deleteIcon: _images.default.delete.default,
    okText: "Ok",
    isLimitExceeded: isLimitExceeded,
    limitOkPress: limitOkPress,
    deleteIconClick: deleteIconClick,
    imagePlaceholder: "Add Description",
    continueText: fromScreen === 'editPhoto' ? "Submit" : "Continue",
    saveText: "Continue",
    deleteText: "Continue",
    continueClicked: continueClicked,
    continueDisabled: fromScreen === "editPhoto" && (_lodash.default.isEqual(initialImages, path) || disable),
    deleteModal: deleteModal,
    trash: _images.default.trash.default,
    onCancelDelete: onCancelDelete,
    deleteHandler: deleteHandler,
    continuePress: true,
    camDivStyle: {
      backgroundColor: "#006E96",
      justifyContent: "center",
      width: "100%",
      height: "45px",
      borderRadius: 10,
      color: "#fff "
    },
    camLabelStyle: {
      width: "100%",
      height: "45px",
      fontWeight: 700,
      marginTop: "10px",
      textAlign: "center"
    },
    hideImageButton: {
      width: "100%",
      height: "45px",
      display: "none"
    },
    windowLayout: windowLayout,
    notUploaded: notUploaded,
    imageNotUploadedClick: imageNotUploadedClick
  }), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: success,
    modalHeaderText: "Photos Updated",
    modalHeaderTextStyle: {
      color: "#4F8309",
      margin: "20px"
    },
    modalDetailText: "Photos have been updated Successfully.",
    customIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.default.successGreenTick.default,
      alt: ""
    }),
    positiveActionButtonTitle: "Continue",
    positiveAction: successContinue
  }));
};
var _default = exports.default = ImageUploadContainer;